function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.286 2.857h3.429A2.286 2.286 0 018 5.143v8a1.714 1.714 0 00-1.714-1.715h-4V2.857z",
  stroke: "#F2F2F2",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.714 2.857h-3.428A2.286 2.286 0 008 5.143v8a1.714 1.714 0 011.714-1.715h4V2.857z",
  stroke: "#F2F2F2",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgMenu;